require('./fiscalDocumentsFilter.scss');

//@vendors
const React = require('react');
const moment = require('moment');
const PropTypes = require('prop-types');

//@commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const DateFilter = require('components/commons/dateFilter/dateFilter');

//@utilities
const { formatText, FormattedText } = require('core/i18n').i18n;


class FiscalDocumentsFilter extends React.Component {
    constructor(props) {
        super(props);

        const immDateFilter = this.props.immFilter.get('date');

        this.state = {
            dateFrom: immDateFilter.get('from'),
            dateTo: immDateFilter.get('to'),
            dateSelected: immDateFilter.get('selected'),
            typeOfDocument: '',
            account: '',
            minDate: moment().startOf('day').subtract('5', 'years'),
        };

        this.setFromDate = this.setFromDate.bind(this);
        this.setToDate = this.setToDate.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleDocumentChange = this.handleDocumentChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
    }

    setFromDate(date) {
        this.setState({
            dateFrom: date
        });
        this.handleChangeDateMin(date);
    }

    setToDate(date) {
        this.setState((previousState) => {
            let object;
            if (previousState.dateFilter.dateFrom && previousState.dateFilter.dateFrom.isAfter(date)) {
                this.handleChangeDateMin(date);
                this.handleChangeDateMax(date);

                object = {
                    dateFrom: date,
                    dateTo: date
                }
            } else {
                this.handleChangeDateMax(date);

                object = {
                    dateTo: date
                }
            }
            return object;
        });
    }

    buildDateFilter() {
        const immDateFilter = this.props.immFilter.get('date');
        return (
            <div>
                <DateFilter
                    immFilter={immDateFilter}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeSelected={this.handleChangeDateSelected}
                />
            </div>
        );
    }

    handleAccountChange(accountId){
        this.setState({account: accountId});
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleDocumentChange(evt) {
        this.setState({typeOfDocument: evt.value});
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const { setFilter, onCloseClick } = this.props;
        const { dateSelected, dateFrom, dateTo, typeOfDocument, account } = this.state;

        setFilter({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            typeOfDocument: {
                type: typeOfDocument
            },
            account: {
                number: account
            }

        });
        onCloseClick();
    }

    renderDocumentType(){
        const { immTypes, groupSelected } = this.props;
        if (groupSelected !== '0000') {

            const groupOption = immTypes.filter((type) => (
                type.get('codGrupo') === groupSelected
            )).map((type, index) => ({
                index: index,
                value: type.get('codTipoComunicacion'),
                label: type.get('desTipoComunicacion')
            })).toJS();

            return (
                <div>
                    <FormattedText className="fiscal-documents-filter__category" value="profileDocumentation-documentType" />
                    <OKSelect
                        clearable={false}
                        matchPos="start"
                        matchProp="label"
                        noResultsText={formatText('profile-selectNotFound')}
                        onChange={this.handleDocumentChange}
                        options={groupOption}
                        placeholder={formatText('profile-selectPlaceholder')}
                        value={this.state.typeOfDocument}
                    />
                </div>
            );
        }
    }

    renderDropdownAccounts() {
        const { immAccounts } = this.props;
        const accountsIndexes = immAccounts.get('byOrder').toJS();
        const accounts = immAccounts.get('byId');

        return (
            <div>
                <FormattedText className="fiscal-documents-filter__category" value="profileDocumentation-accountNumber" />
                <DropdownAccounts
                    id="broker-stocks-contracts"
                    immAccounts={accounts}
                    accountsIndexes={accountsIndexes}
                    currentAccountId={this.state.account}
                    onAccountChange={this.handleAccountChange}
                />
            </div>
        );

    }

    render() {
        const { onCloseClick } = this.props;
        const dropdownAccounts = this.renderDropdownAccounts();
        const dropdownDocumentType = this.renderDocumentType();
        const dateFilter = this.buildDateFilter();

        return (
            <section className="modal-container">
                <FormattedText
                    className="fiscal-documents-filter__title"
                    value="profileDocumentation-filterFiscalDocumentsTitle"
                />
                <form className="fiscal-documents-filter__form modal-container" onSubmit={this.handleFormSubmit}>
                    <div className="modal-scroll-container">
                        { dateFilter }
                        { dropdownAccounts }
                        { dropdownDocumentType }
                    </div>
                    <div className="fiscal-documents-filter__buttons">
                        <div className="pull-left">
                            <OKButton modifier="link-ghost" onClick={onCloseClick}>
                                <FormattedText value="filterDate-cancel" />
                            </OKButton>
                        </div>
                        <div className="pull-right">
                            <OKButton typeButton="submit">
                                <FormattedText value="filterDate-apply" />
                            </OKButton>
                        </div>
                    </div>
                </form>
            </section>
        );
    }
}

FiscalDocumentsFilter.propTypes = {
    groupSelected: PropTypes.string,
    immFilter: PropTypes.object,
    immTypes: PropTypes.object,
    onCloseClick: PropTypes.func.isRequired,
    setFilter: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
};

module.exports = FiscalDocumentsFilter;
